import { render, staticRenderFns } from "./customerPerPrice.vue?vue&type=template&id=5ee37e02"
import script from "./customerPerPrice.vue?vue&type=script&lang=js"
export * from "./customerPerPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports